export default function WelcomeStep({ theme: t }) {
  const features = [
    { icon: '\u{1F4CA}', title: 'Dashboard', desc: 'See income, expenses, and savings at a glance' },
    { icon: '\u{1F4B0}', title: 'Budgets', desc: 'Set monthly limits and track spending per category' },
    { icon: '\u{1F4C5}', title: 'Bills', desc: 'Keep track of recurring bills and due dates' },
    { icon: '\u{1F4C8}', title: 'Reports', desc: 'Year overview with charts and breakdowns' },
  ];

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>{'\u{1F3E0}'}</div>
      <h2 style={{ fontSize: 22, fontWeight: 800, color: t.text, margin: '0 0 8px' }}>
        Welcome to Budget Tracker
      </h2>
      <p style={{ fontSize: 14, color: t.textMuted, marginBottom: 24, lineHeight: 1.5 }}>
        Your household budget, simplified. Let's get you set up in under a minute.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, textAlign: 'left' }}>
        {features.map((f) => (
          <div key={f.title} style={{
            background: t.sectionBg, borderRadius: 10, padding: 14,
            border: '1px solid ' + t.cardBorder,
          }}>
            <div style={{ fontSize: 20, marginBottom: 6 }}>{f.icon}</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: t.text, marginBottom: 2 }}>{f.title}</div>
            <div style={{ fontSize: 12, color: t.textMuted, lineHeight: 1.4 }}>{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
